// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"89d1b926","30":"494fd6cf","59":"276190c3","220":"393b81f1","608":"18484cfc"}[chunkId] + ".chunk.js";
};